import { IScope } from "angular";
import { Observable, Subject } from "rxjs";

export class Ng1DestroyService extends Observable<void> {
  private readonly life$ = new Subject<void>();

  constructor($scope: IScope) {
    super((subscriber) => this.life$.subscribe(subscriber));
    $scope.$on("$destroy", () => {
      this.life$.next();
      this.life$.complete();
    });
  }
}
